import React from 'react';
import { motion } from 'framer-motion';
import Container from '../ui/Container';
import SectionHeader from '../ui/SectionHeader';
import './TechApproach.css';

/** 회사의 업무 역량. 기획서 §6.3 확정 카피 — 과장 없이 사실만. */
const items = [
  {
    label: 'Agent Orchestration',
    headline: '에이전트 오케스트레이션으로 빠르게 만듭니다',
    body:
      'AI 코딩 에이전트 여러 개를 병렬로 운영하는 개발 파이프라인을 갖추고 있습니다. 기획, 구현, 검수를 에이전트가 나눠 맡고 사람은 방향을 결정합니다. 아이디어에서 스토어 출시까지의 주기를 주 단위로 유지합니다.',
  },
  {
    label: 'Gamification',
    headline: '게이미피케이션으로 계속 쓰게 만듭니다',
    body:
      '기능만으로는 습관이 되지 않는다고 생각합니다. 달리고의 캐릭터 러닝메이트처럼, 미션·수집·성장 장치를 제품에 설계해 넣습니다.',
  },
  {
    label: 'Validation',
    headline: '만들기 전에 검증합니다',
    body:
      '시장이 원하는지 먼저 확인하고 만듭니다. 작은 프로토타입으로 반응을 본 뒤 키웁니다. 이 과정을 소상공인도 쓸 수 있게 만든 것이 마켓핏 테스터입니다.',
  },
];

const TechApproach = () => {
  return (
    <section className="ft-tech">
      <Container>
        <SectionHeader
          eyebrow="How We Build"
          align="center"
          title="일하는 방식"
        />

        <ul className="ft-tech__grid">
          {items.map((it, i) => (
            <motion.li
              key={it.label}
              className="ft-tech__item"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            >
              <span className="ft-tech__label">{it.label}</span>
              <h3 className="ft-tech__headline">{it.headline}</h3>
              <p className="ft-tech__body">{it.body}</p>
            </motion.li>
          ))}
        </ul>
      </Container>
    </section>
  );
};

export default TechApproach;
